<template>
  <div
    class="grid-x grid-padding-x vertical-align-middle login-page-contents
    ie-login-page-contents"
  >
    <div class="auto cell" />
    <div class="small-4 cell login-elements">
      <span class="welcome-message">Welcome to the
        <span class="highlighted-text">CRS Dashboard</span>
      </span>
      <br>
      <span class="byline">
        To log in, you will need to have an account set up by your CRS Account Manager.
      </span>
      <div
        v-if="loginFail"
        class="login-fail"
      >
        Incorrect login details
      </div>
      <div
        v-else
        class="login-fail-spacer"
      >
        &nbsp;
      </div>
      <div class="fieldCont">
        <email-field
          :disabled="true"
          v-model="userEmail"
          :name="'userEmail'"
          :placeholder="'Email address'"
          :type="'text'"
          :fail-state="emailValidationFailed"
          :pass-state="emailValidationPassed"
          class="large-input email"
          @blur="validateInput('email', userEmail, 4)"
          @keyup.native="resetValidation('email')"
          @keyup.enter.native="onSubmit"
        />
      </div>
      <div class="fieldCont">
        <password-field
          :disabled="true"
          v-model="userPassword"
          :name="'userPassword'"
          :placeholder="'Password'"
          :type="'password'"
          :fail-state="passwordValidationFailed"
          :pass-state="passwordValidationPassed"
          class="large-input password"
          @blur="validateInput('password', userPassword, 8)"
          @keyup.native="resetValidation('password')"
          @keyup.enter.native="onSubmit"
        />
      </div>
      <div class="grid-x grid-padding-x">
        <div class="cell small-6">
          <login-button
            :button-text="'Login'"
            class="login-button"
            :active="validationComplete"
          />
        </div>
        <div class="cell small-6">
          <forgot-password-link
            :text="'FORGOT DETAILS'"
            style="margin-left: 20px; "
            @clicked="showForgotDetails"
          />
        </div>
      </div>
    </div>
    <div class="auto cell" />
  </div>
</template>

<script>

import InputField from '../../components/form/RareInput.vue';
import Button from '../../components/form/RareStandardButton.vue';
import Link from '../../components/form/RareInlineLink.vue';

export default {
  name: 'RareLogin',
  components: {
    'email-field': InputField,
    'password-field': InputField,
    'login-button': Button,
    'forgot-password-link': Link,
  },
  data() {
    return {
      emailValidationFailed: null,
      emailValidationPassed: null,
      loginErrorMessage: '',
      passwordValidationFailed: null,
      passwordValidationPassed: null,
      userEmail: '',
      userPassword: '',
      loginFail: false,
    };
  },
  computed: {
    validationComplete() {
      return this.emailValidationPassed && this.passwordValidationPassed;
    },
  },
  created() {
    this.$store.commit('updatePageTitle', 'logo');
  },
  mounted() {
    this.track();
    this.$store.commit('updateInitialLoad', true);
    this.$store.commit('updateLoadingModalState', false);
    this.$store.commit('updateShowBurgerMenu', false);
    this.$store.commit('updateShowLogoutIcon', false);
    this.$store.commit('updateShowDownloadIcon', false);
    this.$store.commit('updateShowNavigationLinks', false);
    this.$store.commit('updateShowControlPanel', false);
  },
  beforeDestroy() {
    this.$store.commit('updateCurrentParamsHash');
  },
  methods: {
    track() {
      this.$gtag.pageview({
        page_path: '/login',
      });
    },
    alertUser(error) {
      if (this.userEmail.trim() === '') { this.emailValidationFailed = true; }
      this.passwordValidationFailed = true;
      return error;
    },
    showForgotDetails() {
      // alert('If you have forgotten your password, please contact your CRS Account Manager.');
    },
    onSubmit() {
      this.resetValidation('email');
      this.resetValidation('password');

      const userCredentials = {
        requestUser: this.userEmail,
        requestPassword: this.userPassword,
        resourceIdentifier: 'dashboard',
      };

      this.$store.dispatch('$_login/getAccessTokenUser', userCredentials)
        .then(() => {
          this.$store.dispatch('$_login/getUserData').then((data) => {
            this.$store.dispatch('buildClientList').then(() => {
              this.$store.dispatch('buildIndustryClientLists')
                .then(() => {
                  console.log(data);
                  if (data.client === 'rare') {
                    this.$store.commit('updateClientOrRareMode', 'rare');
                    this.$store.commit('updateCurrentClient', 'all');
                    this.$store.commit('updateCurrentClientDisplayName', 'All Clients');
                    this.$store.commit('updateShowBurgerMenu', true);
                  } else {
                    // eslint-disable-next-line
                    const clientDisplayName = data.display_name;
                    let clientUserName = data.client;

                    console.log(`clientDisplayName - ${clientDisplayName}`);
                    console.log(`clientUserName - ${clientUserName}`);

                    if (clientUserName === clientDisplayName) {
                      console.log('ERROR: clientUserName === clientDisplayName');
                      // eslint-disable-next-line
                      clientUserName = this.$store.getters.getUsernameFromDisplayName(clientDisplayName);
                    }

                    console.log(`clientDisplayName 2 - ${clientDisplayName}`);
                    console.log(`clientUserName 2 - ${clientUserName}`);

                    this.$store.commit('updateClientOrRareMode', 'client');
                    this.$store.commit('updateCurrentClient', clientUserName);
                    this.$store.commit('updateCurrentClientDisplayName', clientDisplayName);
                    this.$store.commit('updateShowBurgerMenu', false);
                  }
                  this.$router.push('/summary');
                }).catch((error) => error);
            }).catch((error) => error);
          }, (error) => {
            this.loginFail = true;
            return error;
          });
        }, (error) => {
          this.loginFail = true;
          return error;
        })
        .catch((error) => error);
    },

    resetValidation(field) {
      switch (field) {
        case 'email':
          this.emailValidationPassed = null;
          this.emailValidationFailed = null;
          break;
        case 'password':
          this.passwordValidationPassed = null;
          this.passwordValidationFailed = null;
          break;
        default:
          break;
      }
    },
    validateInput(field, value, minLength) {
      this.resetValidation(field);
      switch (field) {
        case 'email': /* eslint no-unused-expressions: ["error", { "allowTernary": true }] */
          value.trim !== '' && value.length >= minLength
            ? this.emailValidationPassed = true
            : this.emailValidationFailed = true;
          break;
        case 'password': /* eslint no-unused-expressions: ["error", { "allowTernary": true }] */
          value.trim !== '' && value.length >= minLength
            ? this.passwordValidationPassed = true
            : this.passwordValidationFailed = true;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.login-elements {
  width: 402px;
  margin-top: 100px;
}

.fieldCont {
  height: 50px;
  margin-bottom: 30px;
}

.welcome-message {
  color: 323c44323c44;

  font-size: 21px;
  font-stretch: normal;
  font-style: normal;
  font-weight: bold;
  height: 28px;
  letter-spacing: normal;
  line-height: 1.33;
  text-align: left;
}

.highlighted-text {
  color: $green-highlight;
}

.byline {
  color: #323c44;

  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  font-weight: normal;
  height: 24px;
  letter-spacing: 0.2px;
  line-height: 1.5;
  text-align: left;
}

.login-fail {
  height: 41px;
  margin: 0;
  color: #ee5861;
  font-size: 16px;
  font-weight: bold;
}

.login-fail-spacer {
  height: 41px;
}

.email {
  margin-top: 0;
}

.login-button {
  position: relative;
  top: -12px;
}

.ie-login-page-contents {
  height: calc(100vh - #{134px});
}

</style>
